import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
    name: 'currencyFormat',
    standalone: false
})
export class CurrencyFormatPipe implements PipeTransform {

  public transform(value?: number | string): string {
    if (!value && value !== 0) {
      return ''
    }

    if (typeof value === 'string') {
      value = Number(value)
    }

    if (Number.isNaN(value)) {
      return ''
    }

    return Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value)
  }

}
